"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _snakeToCamel = _interopRequireDefault(require("./snakeToCamel"));
var _default = exports.default = function _default(s) {
  var camelized = (0, _snakeToCamel.default)(s);
  return camelized.charAt(0).toUpperCase() + camelized.slice(1);
};